export default function loadLocaleData(locale: string) {
  // TODO: make dynamic import better
  switch (locale) {
    case "bg":
      return require("./extracted/bg.json");
    default:
      return require("./extracted/en.json");
  }
}
